import { routes } from "jiffy-api";
import { track } from "jiffy-analytics";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import ButtonBox from "components/jiffy/button-box/ButtonBox.react.vue";
import "./ArtworkCTA.scss";

export default function ArtworkCTA({ artworkUrl = "", ...restProps }) {
  function borneoPath() {
    const borneoPathValue = routes.borneoRootPath();
    return artworkUrl !== ""
      ? `${borneoPathValue}?borneo_image_url=${encodeURIComponent(artworkUrl)}`
      : borneoPathValue;
  }

  function trackCTAEvent() {
    track("borneo_editor_open_button_clicked", {
      source: "gong_cta"
    });
  }

  return (
    <div {...restProps} className={cn("artwork-cta scope-bef93bcc", restProps.className)}>
      <a
        className="artwork-cta__features-list scope-bef93bcc"
        href={borneoPath()}
        onClick={trackCTAEvent}
        data-testid="artwork-cta-features-list"
      >
        <div className="artwork-cta__feature scope-bef93bcc">
          <div className="artwork-cta__feature-text scope-bef93bcc">
            <span className="artwork-cta__feature-text-highlight scope-bef93bcc">
              Free 150,000 Fonts
            </span>
          </div>
        </div>
        <div className="artwork-cta__feature scope-bef93bcc">
          <UseSvg
            className="artwork-cta__feature-icon scope-bef93bcc"
            icon="check-curvy"
            data-testid="artwork-cta-feature-icon"
          />
          <div className="artwork-cta__feature-text artwork-cta__feature-text--small scope-bef93bcc">
            {" "}
            Commercial use allowed{" "}
          </div>
        </div>
      </a>
      <div className="artwork-cta__intro scope-bef93bcc">
        <div className="artwork-cta__intro-header scope-bef93bcc">
          <div className="artwork-cta__intro-header-first-line scope-bef93bcc">introducing...</div>
          <div className="artwork-cta__intro-header-second-line scope-bef93bcc">
            <UseSvg
              className="artwork-cta__intro-header-second-line-icon scope-bef93bcc"
              icon="borneo"
              data-testid="artwork-cta-intro-header-second-line-icon"
            />
          </div>
        </div>
        <div className="artwork-cta__intro-upload-file scope-bef93bcc">
          <ButtonBox
            className="artwork-cta__button scope-bef93bcc"
            type="button"
            href={borneoPath()}
            onClick={trackCTAEvent}
            data-testid="artwork-cta-button"
          >
            {"Edit your artwork"}
          </ButtonBox>
        </div>
      </div>
    </div>
  );
}
